export const RedirectToArticleSource = (e: any, row: any, history: any) => {
  const articleSource = row.articleLink;
  window.open(articleSource);
};
